import Swiper from "swiper/bundle";
import "swiper/css/bundle";
if (document.querySelector(".swiper-primary")) {
  const swiper = new Swiper(".swiper-primary", {
    slidesPerView: 1,

    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 15000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      // dynamicBullets: true,
    },
    on: {
      init: function () {
        updatePaginationPosition(this);
      },
      slideChange: function () {
        updatePaginationPosition(this);
      },
      resize: function () {
        updatePaginationPosition(this);
      },
    },
  });

  function updatePaginationPosition(swiperInstance) {
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    const dotsContainer = activeSlide.querySelector(".banner-primary__dots");
    const pagination = document.querySelector(".banner-primary__pagination");

    if (!dotsContainer || !pagination) return;

    dotsContainer.appendChild(pagination);
  }

  window.addEventListener("resize", function () {
    updatePaginationPosition(swiper);
  });
}
const swiperNews = new Swiper(".swiper-news, .swiper-project-showcase", {
  spaceBetween: 30,

  breakpoints: {
    375: {
      slidesPerView: 1,
    },
    980: {
      slidesPerView: 2,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
const swiperInvestigationLines = new Swiper(
  ".swiper-investigation-lines, .swiper-testimonials, .swiper-resources",
  {
    spaceBetween: 20,
    breakpoints: {
      375: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 2,
      },
      1040: {
        slidesPerView: 3,
      },
    },
    autoplay: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
  }
);
const swiperInvestigationLinesTwo = new Swiper(
  ".investigation-lines--two, .swiper-videos--two",
  {
    spaceBetween: 20,
    breakpoints: {
      375: {
        slidesPerView: 1,
      },
      740: {
        slidesPerView: 2,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
  }
);
const swiperGalery = new Swiper(".swiper-galery", {
  spaceBetween: 20,
  breakpoints: {
    375: {
      slidesPerView: 1.5,
    },
    740: {
      slidesPerView: 2.5,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
const swiperCardsPosts = new Swiper(".swiper-cards-posts", {
  spaceBetween: 20,

  breakpoints: {
    375: {
      slidesPerView: 1,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
const swiperCalls = new Swiper(".swiper-cards-calls", {
  spaceBetween: 30,

  breakpoints: {
    375: {
      slidesPerView: 1,
    },
    940: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1440: {
      slidesPerView: 4,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiperEvents = new Swiper(".swiper-cards-events, .swiper-videos", {
  spaceBetween: 30,

  breakpoints: {
    375: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1440: {
      slidesPerView: 4,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiperModels = new Swiper(".swiper-models", {
  spaceBetween: 50,
  breakpoints: {
    375: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1440: {
      slidesPerView: 4,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
const swiperEventsTeachers = new Swiper(
  ".swiper-shortcode-teachers, .swiper-magazines",
  {
    spaceBetween: 30,

    breakpoints: {
      375: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 2,
      },
      980: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 5,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  }
);
const swiperPublications = new Swiper(".swiper-cards-publications", {
  spaceBetween: 30,

  breakpoints: {
    375: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiperLogos = new Swiper(".swiper-logos", {
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: ".logos-interest__nav--next",
    prevEl: ".logos-interest__nav--prev",
  },
  pagination: {
    el: ".logos-interest__pagination",
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    375: { slidesPerView: 1.4 },
    640: { slidesPerView: 3 },
    980: { slidesPerView: 4 },
    1280: { slidesPerView: 5 },
    1440: { slidesPerView: 6 },
  },
});
const swiperSpaces = new Swiper(".swiper-spaces", {
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
const swiperDirectory = new Swiper(".swiper-directory-tdea", {
  grid: {
    rows: 2,
  },
  breakpoints: {
    375: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 3,
    },
    980: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 5,
    },
  },
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});

const swiperBD = new Swiper(".swiper-bd", {
  spaceBetween: 30,

  breakpoints: {
    375: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2.3,
    },
    980: {
      slidesPerView: 3.3,
    },
    1024: {
      slidesPerView: 4.3,
    },
    1440: {
      slidesPerView: 5.3,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const swiperRadio = new Swiper(".single-post__slide-swiper, .swiper-radio", {
  slidesPerView: 1,
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
const swiperRadioHome = new Swiper(".swiper-radio-home", {
  slidesPerView: 1,
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 20000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
